<template>
  <div/>
</template>

<script>
export default {
  name: 'logout',
  metaInfo: {
    title: 'Logout',
  },
  mounted () {
    this.$store.dispatch('user/logout');
  },
};
</script>
